import * as Sentry from '@sentry/react';

export const setSentryTag: typeof Sentry.setTag = (key, value) =>
  Sentry.setTag(key, value);
